import React from "react";
import SearchPost from "./SearchPost/SearchPost";

var styles = {
  noListContainer: {
    display: "flex",
    marginTop: "20px",
    alignItems: "center",
    flexDirection: "column",
  },
};

export default ({ posts, total, teamId, loading }) => {
  const classes = styles;

  if (total === 0 && !loading) {
    return (
      <React.Fragment>
        <div style={classes.noListContainer}>
          <div className="noPostText">
            <span>No result</span>
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {posts.map((post, index) => (
        <SearchPost key={index} post={post} index={index} teamId={teamId} />
      ))}
    </React.Fragment>
  );
};
